import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../interfaces/IFilter";
import ProgramacionService from "../../services/ProgramacionService";

const UseComboTipoProgramacion = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboTipoProgramacion, setDataComboTipoProgramacion] = useState<IComboBoxOption[]>([]);
    const comboBoxRefTipoProgramacion = useRef<IComboBox>(null);

    const onClickComboTipoProgramacion = () => comboBoxRefTipoProgramacion.current?.focus(true);

    const _openOption = useCallback(
        () => comboBoxRefTipoProgramacion.current?.focus(true),
        []
    );

    const _onkeyUpSearchTipoProgramacion = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefTipoProgramacion.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        ProgramacionService.allTipoProgramacion().then((res) => {
            if (res.status === 200) {
                setDataComboTipoProgramacion(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen, filter]);

    return {
        dataComboTipoProgramacion,
        onClickComboTipoProgramacion,
        _onkeyUpSearchTipoProgramacion,
        comboBoxRefTipoProgramacion,
        filter,
        setFilter
    };
}

export { UseComboTipoProgramacion }
